import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from '../assets/images/Gallery-frame.jpg';
import usePageSEO from "../hooks/usePageSEO";



export default function Home() {

    usePageSEO({
        title: "Art Gallery in UAE- Qube Art Gallery - Dubai, Abu Dhabi",
        description: "We are a team of creators – close-knit and a little crazy – collecting and restoring exquisite pieces of Artwork in Dubai UAE. We present Art to be cherished in your home & workspaces.", 
        keywords: ["Qube Art" , "Qube Artis"],
        ogTitle: "", 
        ogDescription: "", 
        ogImage: "", 
        ogUrl: "https://www.qubeartgallery.com/"
        })

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 520,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 3
            }
          }, {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
      };

      const box_slider = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 520,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 3
            }
          }, {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
      };



      const cust_logos = {
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        dots: false,
            pauseOnHover: false,
            responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 2
            }
        }]

      };


 return (
    <div>

   
<section class="main-slider">
<div class="carousel fade-carousel slide" data-ride="carousel" data-interval="4000" id="bs-carousel">

  <div class="overlay"></div>

  <ol class="carousel-indicators">
    <li data-target="#bs-carousel" data-slide-to="0" class="active"></li>
    <li data-target="#bs-carousel" data-slide-to="1"></li>
    <li data-target="#bs-carousel" data-slide-to="2"></li>
  </ol>
  

  <div class="carousel-inner">
    <div class="item slides active">
      <div class="slide-1"></div>
      <div class="hero">
        <hgroup>
            <h1>We are creative</h1>        
            <h3>Get start your next awesome project</h3>
        </hgroup>
        <a href="/home" class="btn btn-hero btn-lg" role="button">See all features</a>
      </div>
    </div>
    <div class="item slides">
      <div class="slide-2"></div>
      <div class="hero">        
        <hgroup>
            <h1>We are smart</h1>        
            <h3>Get start your next awesome project</h3>
        </hgroup>       
        <a href="/home" class="btn btn-hero btn-lg" role="button">See all features</a>
      </div>
    </div>
    <div class="item slides">
      <div class="slide-3"></div>
      <div class="hero">        
        <hgroup>
            <h1>We are amazing</h1>        
            <h3>Get start your next awesome project</h3>
        </hgroup>
        <a href="/home" class="btn btn-hero btn-lg" role="button">See all features</a>
      </div>
    </div>
  </div> 
</div>
</section>

<section class="framing-row">

    <div class="container">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

               <div class="sub-title"><h2 style={{textAlign: "center", fontWeight: "700" }}>Framing at Qube Art Gallery</h2></div>
            </div>
            <div class="col-md-3 col-xs-6">
                 <h2 class="wpb_singleimage_heading">Gallery Standard</h2>
                <img src={img1} alt="" />
                    <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/gallery-frames-wood-metal/">Gallery Frames – Wood & Metal</a></p>

	                 </div>
            </div>

            <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">Best in class</h2>
                <img src="images/art-glass.jpg" alt="" />
                <div class="recommend-url">
	
			<p><a href="https://www.qubeartgallery.com/framing/art-glass/">Art Glass AR 70, UV 99 & AR 99</a></p>

		
	            </div>
            </div>

            <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">ARCHIVAL STANDARD</h2>
                 <img src="images/MUSEUM-QUALITY-FRAMES.jpg" alt="" />
                 <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/museum-framing/">Museum Quality Frames</a></p>
	            </div>
            </div>

            <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">SPECIALISED PRODUCT</h2>
                <img src="images/Round-Format-_-Shapes.jpg" alt="" />
                <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/round-format-shapes/">Round Format &amp; Shapes</a></p>

		
	            </div>
            </div>

        </div>

        <div class="row mt-n1">

        <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">Gallery Standard</h2>
                <img src="images/flotted-frame-600x450.jpg" alt="" />
                <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/floating-frames/">Floating Frames for Canvases</a></p>

		
	            </div>
            </div>


            <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">SPECIALISED PRODUCT</h2>
                <img src="images/t-shirt-frame-2-2copy-copy.jpg" alt="" />
                <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/memorabilia-framing/">Memorabilia Framing
            for T-Shirts</a></p>

		
	            </div>
            </div>

            <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">BEST IN CLASS</h2>
                <img src="images/Metal-Print-copy.jpg" alt="" />
                <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/memorabilia-framing/">Metal Prints</a></p>

		
	            </div>
            </div>


            <div class="col-md-3 col-xs-6">
            <h2 class="wpb_singleimage_heading">ARCHIVAL STANDARD</h2>
                <img src="images/Conservation-Frames.jpg" alt="" />
                <div class="recommend-url">
		
			<p><a href="https://www.qubeartgallery.com/framing/conservation-framing/">Conservation Framing</a></p>

		
	            </div>
            </div>

        </div>
        </div>

    </div>



</section>

<section>


<script src="platform.js" async></script>
<div class="elfsight-app-9019749e-2459-431f-8f1d-da5803b759e0" data-elfsight-app-lazy></div>
</section>

<section class="slick-box-slider-1">
   <div class="sub-title">
         <h2>Services for Professionals</h2>
     </div>
     <div class="slick-container">
         <div class="ct-box-sliderq ct-js-box-slider">

             <div class="item">
                 <div class="container-fluid">
                     <div class="row">
                     <Slider {...settings}>
                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/hospitality" class="promo-item__img">
                                         <img src="images/hospitality.jpg" alt=""/>
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/hospitality">Hospitality</a>
                                         </h3>
                                         <div class="promo-item__description"><p>Enrich your guest’s experiences with visual treats of exclusive Artwork, mirrors & accessories</p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>

                      
                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/galleries-and-museum" class="promo-item__img">
                                         <img src="images/galleries-and-museum.jpg" alt=""/>
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/galleries-and-museum">Galleries & Museum</a>
                                         </h3>
                                         <div class="promo-item__description"><p>Displaying the most historically significant, visually inspiring and meaningful pieces of art requires</p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>
                       
                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/corporates-and-retail-stores" class="promo-item__img">
                                         <img src="images/corporates-and-retail-stores.jpg" alt=""/>
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/corporates-and-retail-stores">Corporates & Retail Stores</a>
                                         </h3>
                                         <div class="promo-item__description"><p>If you’re looking for the perfect design service and consultation to enrich your customer’s in-store</p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>


                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/residence-and-villas" class="promo-item__img">
                                         <img src="images/residence-and-villas.jpg" alt="" />
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/residence-and-villas">Residence & Villas</a>
                                         </h3>
                                         <div class="promo-item__description"><p>Your house is a reflection of your personality and style. At QUBE, we’d like to ensure that you find </p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>

                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/art-enthusiasts" class="promo-item__img">
                                         <img src="images/art-enthusiasts.jpg" alt=""/>
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/art-enthusiasts">Art Enthusiasts</a>
                                         </h3>
                                         <div class="promo-item__description"><p>Artist treats their art as a piece of their soul and we believe we can provide the ideal framing</p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>

                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/interior-designers" class="promo-item__img">
                                         <img src="images/interior-designers.jpg" alt=""/>
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/interior-designers">Interior Designers</a>
                                         </h3>
                                         <div class="promo-item__description"><p>We understand that as an Interior designer your at-most important is to ensure your customer has</p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>

                         <div class="col-xs-12 col-sm-4">
                             <div class="swiper-slide">
                                 <div class="promo-item">
                                     <a href="services/by-trade/artists-and-photographers" class="promo-item__img">
                                         <img src="images/artists-and-photographers.jpg" alt=""/>
                                     </a>
                                     <div class="promo-item__box">
                                         <h3 class="h5 promo-item__title">
                                             <a href="services/by-trade/artists-and-photographers">Artists And Photographers</a>
                                         </h3>
                                         <div class="promo-item__description"><p>Effortlessly reproduce your best captured moments in the fullness of colour, light, and life never</p>
                                         </div>

                                     </div>
                                 </div>
                             </div>
                         </div>

                    

</Slider>



                     </div>
                 </div>
             </div>

        
         </div>
         </div>
 </section>

<section class="slick-box-slider-2">
<div class="sub-title">
    <h2>Working with UAE's artists & brands since 2010</h2>
</div>    
<div class="slick-container">
<div class="ct-box-slider2 ct-js-box-slider2">
    
  <div class="item">
    <div class="container-fluid">
    <div class="row">
    <Slider {...box_slider}>
      <div class="col-xs-12 col-sm-4">
       <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/picture-framing" class="promo-item__img">
                    <img src="images/picture-framing.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/picture-framing">Picture Framing </a>
                    </h3>
                <div class="promo-item__description"><p>QUBE Art Gallery offers a vast range of Picture Framing Services that are customizable to suit your style and preference.</p>
                </div>
    
                </div>
            </div>
          </div>
      </div>
      <div class="col-xs-12 col-sm-4">
       <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/fine-art-printing" class="promo-item__img">
                    <img src="images/fine-art-printing.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/fine-art-printing">Fine Art Printing</a>
                    </h3>
                <div class="promo-item__description"><p>Our printing techniques give you consistent and long-lasting fine art prints on a range of different papers and canvas.</p>
                </div>
    
                </div>
            </div>
          </div>
      </div>
      <div class="col-xs-12 col-sm-4">
        <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/art-installation" class="promo-item__img">
                    <img src="images/art-installation.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/art-installation">Art Installation</a>
                    </h3>
                <div class="promo-item__description"><p>A particular artwork or installation is unique in its meaning and quality and it’s equally important to ensure it’s </p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-sm-4">
        <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/art-sourcing" class="promo-item__img">
                    <img src="images/art-sourcing.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/art-sourcing">Art Sourcing </a>
                    </h3>
                <div class="promo-item__description"><p>At Qube, we have an art bank of over 200,000+ artworks that you can choose from. With our special Art Sourcing service,</p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-sm-4">
        <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/wall-mural" class="promo-item__img">
                    <img src="images/wall-mural.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/wall-mural">Wall Murals </a>
                    </h3>
                <div class="promo-item__description"><p>A mural is any piece of artwork painted or applied directly on a wall, ceiling or other permanent surfaces.</p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-sm-4">
        <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/graffiti-art" class="promo-item__img">
                    <img src="images/graffiti-art.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/graffiti-art">Graffiti Art </a>
                    </h3>
                <div class="promo-item__description"><p>At QUBE Art Gallery, we’ve worked meticulously to curate a vast range of affordable Graffiti / street artworks to </p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-sm-4">
       <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/scanning-and-retouching" class="promo-item__img">
                    <img src="images/scanning-and-retouching.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/scanning-and-retouching">Scanning & Retouching </a>
                    </h3>
                <div class="promo-item__description"><p>We also provide services where we are able to scan and reproduce images of your choice in multiple size requirements </p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-sm-4">
       <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/fine-art-printing" class="promo-item__img">
                    <img src="images/fine-art-printing.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/fine-art-printing">Fine Art Printing</a>
                    </h3>
                <div class="promo-item__description"><p>Our printing techniques give you consistent and long-lasting fine art prints on a range of different papers and canvas.</p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-sm-4">
        <div class="swiper-slide">
            <div class="promo-item">
                 <a href="services/by-type/art-installation" class="promo-item__img">
                    <img src="images/art-installation.jpg" alt="" />
                 </a>
                <div class="promo-item__box">
                    <h3 class="h5 promo-item__title">
                    <a href="services/by-type/art-installation">Art Installation</a>
                    </h3>
                <div class="promo-item__description"><p>A particular artwork or installation is unique in its meaning and quality and it’s equally important to ensure it’s </p>
                </div>
    
                </div>
            </div>
          </div>
      </div>

</Slider>

    </div>
    </div>
  </div>
</div>
</div>

</section>

<section class="logo-slider">

         <div class="client-logos">

         <h2 class="slider-title">-TRUSTED BY-</h2>
         
         <div class="customer-logos">
         <Slider {...cust_logos}>
<div class="slide"><img src="images/logos/10.png" alt="" /></div>
<div class="slide"><img src="images/logos/17.png" alt="" /></div>
  <div class="slide"><img src="images/logos/2.png" alt="" /></div>
  <div class="slide"><img src="images/logos/3.png" alt="" /></div>
  <div class="slide"><img src="images/logos/4.png" alt="" /></div>
<div class="slide"><img src="images/logos/15.png" alt="" /></div>
<div class="slide"><img src="images/logos/5.png" alt="" /></div>
 <div class="slide"><img src="images/logos/11.png" alt="" /></div>
  
<div class="slide"><img src="images/logos/16.png" alt="" /></div>
  <div class="slide"><img src="images/logos/6.png" alt="" /></div>
  <div class="slide"><img src="images/logos/7.png" alt="" /></div>
  
  <div class="slide"><img src="images/logos/9.png" alt="" /></div>
<div class="slide"><img src="images/logos/8.png" alt="" /></div>
 <div class="slide"><img src="images/logos/12.png" alt="" /></div>
  <div class="slide"><img src="images/logos/13.png" alt="" /></div>
<div class="slide"><img src="images/logos/18.png" alt="" /></div>
  <div class="slide"><img src="images/logos/14.png" alt="" /></div>
  
  <div class="slide"><img src="images/logos/19.png" alt="" /></div>
  <div class="slide"><img src="images/logos/20.png" alt="" /></div>
<div class="slide"><img src="images/logos/21.png" alt="" /></div>
<div class="slide"><img src="images/logos/23.png" alt="" /></div>
<div class="slide"><img src="images/logos/24.png" alt="" /></div>
<div class="slide"><img src="images/logos/jotun.png" alt="" /></div>
</Slider>
</div>


         </div>

</section>
       
       
       
         </div>
 )

}

